var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"float",attrs:{"href":"https://api.whatsapp.com/send?phone=6287875943171","target":"_blank"}},[_c('img',{staticClass:"floating-whatsapp",attrs:{"src":require("@/assets/img/icons/social-media/floating-whatsapp.png"),"alt":"floating-whatsapp"}})])
}]

export { render, staticRenderFns }